export const { VUE_APP_API_GOOGLE_MAPS: API_GOOGLE_MAPS } = process.env;
